// test2748
(2748 && 0);
